// extracted by mini-css-extract-plugin
export default {"container":"SC-z","dimension":"TC-z","dimensionLabels":"UC-z"};